import { Component, Inject, OnInit } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { AUTH_PROVIDER_TOKEN, AuthProvider } from '../../core/tokens/auth-provider.token';

/**
 * Unified login callback component.
 * Okta: calls handleLoginRedirect() to store tokens and navigate to the original URI.
 * Entra: the redirect is already processed in APP_INITIALIZER via handleRedirectObservable();
 *       this component is just a routing placeholder.
 */
@Component({
  selector: 'app-auth-callback',
  standalone: true,
  imports: [],
  template: ``,
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    @Inject(AUTH_PROVIDER_TOKEN) private readonly authProvider: AuthProvider,
    @Inject(OKTA_AUTH) private readonly oktaAuth: OktaAuth,
  ) {}

  ngOnInit(): void {
    if (this.authProvider === 'Okta') {
      this.oktaAuth.handleLoginRedirect().catch((e) => console.error(e));
    }
  }
}
